import { render, staticRenderFns } from "./test_main.vue?vue&type=template&id=708dca3e&scoped=true"
import script from "./test_main.vue?vue&type=script&lang=js"
export * from "./test_main.vue?vue&type=script&lang=js"
import style0 from "./test_main.vue?vue&type=style&index=0&id=708dca3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708dca3e",
  null
  
)

export default component.exports